import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { CoreConfigService } from '@core/services/config.service';
import { LoginService } from 'app/services/auth/login.service';

@Component({
  selector: 'app-create-station',
  templateUrl: './create-station.component.html',
  styleUrls: ['./create-station.component.scss']
})
export class CreateStationComponent implements  OnInit {
  displayPassword="password";
  public coreConfig: any;
  public loginForm: UntypedFormGroup;
  public loading = false;
  public submitted = false;
  public returnUrl: string;
  public error = '';
  data:any={ 
    titre:"",
    nb_employer:"",
    type:"",

    
  }
  dataError:any={
          titre:"",
          nb_employer:"",
          type:"",
       
  }
   stationTypes = [
    'Type 1', 'Type 2', 'Type 3', 'Type 4', 'Type 5',
    'Type 6', 'Type 7', 'Type 8', 'Type 9', 'Type 10',
    'Type 11', 'Type 12', 'Type 13', 'Type 14', 'Type 15',
    'Type 16', 'Type 17', 'Type 18', 'Type 19', 'Type 20',
    'Type 21', 'Type 22', 'Type 23', 'Type 24', 'Type 25',
    'Type 26', 'Type 27', 'Type 28', 'Type 29', 'Type 30'
  ];
  countdown: number = 60;
interval: any;
canResend: boolean = false;
  validate=false;
  public passwordTextType: boolean;
errorMessage:any="";
  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   */
  constructor(
    private loginService:LoginService,
    private _coreConfigService: CoreConfigService,
    private _formBuilder: UntypedFormBuilder,
    private _route: ActivatedRoute,
    private _router: Router
  ) {
    this._unsubscribeAll = new Subject();

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }

 

 
 

  
  ngOnInit(): void {
    this.loginForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
    this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
     
  }
   create() {
    
    if (!this.validates()) {
      return;
    }
     let user = localStorage.getItem('currentUser');
  let users = JSON.parse(user);
    this.data.user=users.id;
    this.loading = true;
    console.log(this.data)
   this.loginService.createStation(this.data)
          .subscribe(
            data => {
                console.log(data)
                if(data.user)
                {
                  if(data.user.stations[0])
                  {
                    data.user.stations[0].isConnecte=1;
                    var i=0;
                    data.user.stations.forEach(element => {
                      if(i!=0)
                      {
                           element.isConnecte=0;
                      }
                      i++;
                     
                    });
                  }
                    localStorage.setItem('currentUser',JSON.stringify(data.user));
                    const titre = String(this.data.titre || '').trim();
                    if (titre) {
                      localStorage.setItem('registration_nom_entreprise', titre);
                    }
                    this._router.navigate(["/main/parametre/entreprise"]);
                  
                }
         
            },
            error => {
           

            }
          );
  }

  validates() {
    this.dataError.titre = this.data.titre.trim() ? '' : 'Le nom de l\'entreprise est obligatoire';
    this.dataError.nb_employer = this.data.nb_employer ? '' : 'Veuillez choisir un nombre d\'employés';
   

    return !this.dataError.titre && !this.dataError.nb_employer && !this.dataError.type;
  }





}